import type { TDeliveryStatus } from '@alfa-bank/site-dc-form-api/src/models';

export const THANK_PAGE_STATUSES: Record<TDeliveryStatus, TDeliveryStatus> = {
    COURIER_DELIVERY: 'COURIER_DELIVERY',
    ANY_OFFICE: 'ANY_OFFICE',
    UNNAMED_OFFICE: 'UNNAMED_OFFICE',
    NAMED_OFFICE: 'NAMED_OFFICE',
};

// Константы для наименований некарточных продуктов
export const SERVICE_INDIVIDUAL_SALARY_CLIENT = 'INDIVIDUAL_SALARY_CLIENT';
export const SERVICE_ALPHA_SMART = 'ALPHA_SMART';

// Список некарточных продуктов для показа информера
export const REQUIRED_SERVICES = [SERVICE_INDIVIDUAL_SALARY_CLIENT, SERVICE_ALPHA_SMART];
